module.exports = __webpack_public_path__ + "img/Fluke_logo.0f1e978d.jpg";